import React, { Component } from 'react'

import { ApplicationError } from '@views/applicationError'

export type ErrorBoundaryProps = { error?: Error; errorInfo?: React.ErrorInfo; children?: React.ReactNode }

type State = {
  error?: Error
  errorInfo?: React.ErrorInfo
  hasError?: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
  state = {
    error: undefined,
    errorInfo: undefined,
    hasError: false,
  }

  static getDeriveredStateFromError = () => {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ error, errorInfo })
  }

  render() {
    if (this.state.errorInfo) {
      const { errorInfo } = this.state

      return <ApplicationError errorMessage={errorInfo} />
    } else {
      return this.props.children
    }
  }
}
